import {
  FETCH_PAYMENT_TYPE,
  CREATE_PAYMENT_TYPE,
  UPDATE_PAYMENT_TYPE,
  DELETE_PAYMENT_TYPE,
  DELETE_M_PAYMENT_TYPE
} from "../actions";
const initialState = {
  // deleted:null,
  selectedToDelete: null,
  newPaymentType: null,
  updatedPaymentType: null,
  paymentTypes: [],
  loading: false,
  newPaymentTypeError: null,
  fetchPaymentTypeError: null,
  updatePaymentTypeError: null,
  deletePaymentTypeError: null,
  deleteMPaymentTypeError: null
};

function paymentTypeReducer(state = initialState, action) {
  let selectedToDelete, newPaymentType, updatedPaymentType, paymentTypes;

  switch (action.type) {
    case `${FETCH_PAYMENT_TYPE}_PENDING`:
    case `${CREATE_PAYMENT_TYPE}_PENDING`:
    case `${UPDATE_PAYMENT_TYPE}_PENDING`:
    case `${DELETE_PAYMENT_TYPE}_PENDING`:
    case `${DELETE_M_PAYMENT_TYPE}_PENDING`:
      return { ...state, loading: true };

    case `${FETCH_PAYMENT_TYPE}_FULFILLED`:
      paymentTypes = action.payload.data;
      return { ...state, loading: false, paymentTypes };
    case `${CREATE_PAYMENT_TYPE}_FULFILLED`:
      newPaymentType = action.payload.data;
      return { ...state, loading: false, newPaymentType };
    case `${UPDATE_PAYMENT_TYPE}_FULFILLED`:
      updatedPaymentType = action.payload.data;
      return { ...state, loading: false, updatedPaymentType };
    case `${DELETE_PAYMENT_TYPE}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: true, selectedToDelete };
    case `${DELETE_M_PAYMENT_TYPE}_FUlFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };

    case `${FETCH_PAYMENT_TYPE}_REJECTED`:
      return {
        ...state,
        loading: false,
        fetchPaymentTypeError: `${action.payload.message}`,
        state: initialState
      };
    case `${CREATE_PAYMENT_TYPE}_REJECTED`:
      return {
        ...state,
        loading: false,
        newPaymentTypeError: `${action.payload.message}`,
        state: initialState
      };
    case `${UPDATE_PAYMENT_TYPE}_REJECTED`:
      return {
        ...state,
        loading: false,
        updatePaymentTypeError: `${action.payload.message}`,
        state: initialState
      };
    case `${DELETE_PAYMENT_TYPE}_REJECTED`:
      return {
        ...state,
        loading: false,
        deletePaymentTypeError: `${action.payload.message}`,
        state: initialState
      };
    case `${DELETE_M_PAYMENT_TYPE}_REJECTED`:
      return {
        ...state,
        loading: false,
        deleteMPaymentTypeError: `${action.payload.message}`,
        state: initialState
      };

    default:
      return state;
  }
}
export default paymentTypeReducer;
